import Swal from 'sweetalert2'
import { screenTransition } from './flutter'

export const errorAlertApp = (error: any) => {
    let message : string = "";
    if ((typeof error === "string" || error instanceof String)) {
        message = <string>error;
    } else {
        if (error.message == "Request aborted") {
            return;
        }
        message = (typeof error.message !== "undefined" ? error.message : "");
        if (typeof error.response !== "undefined") {
            if (typeof error.response.data.message !== "undefined") {
                message = error.response.data.message;
            }
            if (typeof error.response.data.errors !== "undefined") {
                message = "";
                for (let errorItem in error.response.data.errors) {
                    message += error.response.data.errors[errorItem][0] + "<br>";
                }
            }
        }
    }
    Swal.fire({
        html: message,
        cancelButtonColor:'#f90707',
        showCancelButton:false,
        confirmButtonText: 'OK'
    }).then(() => {
        if (typeof error.response !== 'undefined' && typeof error.response.data !== 'undefined' && typeof error.response.data.location !== "undefined") {
            screenTransition('login');
        }
    });
}

export const successAlertApp = async (success: any) : Promise<any> => {
    let message = success;
    return Swal.fire({
        html: message,
        showCancelButton:false,
        confirmButtonColor : '#0427D6',
        confirmButtonText: 'OK'
    });
}

export const confirmAlertApp = async (confirmMessage: string) : Promise<any> => {
    return Swal.fire({
        html: confirmMessage,
        focusConfirm: true,
        showCancelButton:true,
        confirmButtonColor : '#0427D6',
        cancelButtonColor:'#f90707',
        confirmButtonText: 'OK'
    });
}
